import { render, staticRenderFns } from "./PageBar.vue?vue&type=template&id=7465efd0"
import script from "./PageBar.vue?vue&type=script&lang=js"
export * from "./PageBar.vue?vue&type=script&lang=js"
import style0 from "./PageBar.vue?vue&type=style&index=0&id=7465efd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports